module.exports = __webpack_public_path__ + "media/images/writer/story_achievement_mailer/ogp_image_5000-fd8ea005dfdcac4b107bf70ffd86c631.png";